enum MutationType {
  CLOSE_MAIN_WS = "mws/CLOSE_MAIN_WS",
  SETUP_MAIN_WS = "mws/SETUP_MAIN_WS",
}

export default MutationType;
